import * as PatientApis from '../apis/patient';
import * as ActionTypes from '../constants/actions';
import _ from 'lodash';

export function postActiveCall(data, callback, errorCallback) {
	return async (dispatch) => {
		const response = await PatientApis.postActiveCall(data);
		let activeCall = response.data;
		if(response.status === "200"){
			window.localStorage.setItem("patientCallId", activeCall[0].callId)
			dispatch(setActiveCallDetails(activeCall[0]));
			if (callback) {
				return callback();
			}
		}else{
			if (errorCallback) {
				return errorCallback();
			}
		}
	};
}

export function getActiveCallDetails(data, callback) {
	return async (dispatch) => {
		const response = await PatientApis.getActiveCallDetails(data);
		let activeCall = response.data;
		if(activeCall){
			dispatch(setActiveCallDetails(activeCall[0]));
			if (callback) {
				return callback(activeCall[0]);
			}
		}
	};
}

export function getParticipants(data, callback) {
	return async (dispatch) => {
		const response = await PatientApis.getParticipants(data);
		if(response.data){
			dispatch(setParticipants(response.data));
			if (callback) {
				return callback();
			}
		}
	};
}


export function setActiveCallDetails(activeCall) {
	return {
		type : ActionTypes.PATIENTS.SET_ACTIVE_CALL_DATA,
        activeCall
	};
}

export function setParticipants(participants) {
	return {
		type : ActionTypes.PARTICIPANTS.SET_PARTICIPANTS,
        participants
	};
}


export function unsetActiveCallDetails() {
	return {
		type : ActionTypes.PATIENTS.UNSET_ACTIVE_CALL_DATA
	};
}


export function getParticipantList(therapistRoom, callback) {
	return async (dispatch) => {
		
		const response = await PatientApis.getParticipants(therapistRoom);
		if(response.data && response.data.length > 2){
			window.localStorage.setItem('newParticipant', "true")
		} else{
			window.localStorage.removeItem('newParticipant')
		}

		// await PatientApis.getParticipants(therapistRoom).then(result => { 
		// 	if (result.data && result.data.length >= 2) { 
		// 		window.localStorage.setItem('newParticipant', "true")
		// 	} else{
		// 		window.localStorage.removeItem('newParticipant')
		// 	}
		// }).catch(e => {
		// 	console.log(e)
		// })
	};
}